const ITEMS = [
  "Sonic Identity",
  "Audio Logos",
  "Music Strategy",
  "Campaign Sound",
  "Podcast Production",
  "Brand Distinction",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="border-y border-[#121110]/10 bg-[#F3EFEA] py-6 overflow-hidden">
      <div className="marquee-track">
        {row.map((word, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic font-light text-3xl sm:text-4xl text-[#121110] px-8">
              {word}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#C5A880]" />
          </span>
        ))}
      </div>
    </section>
  );
}
